package app.bloomey.web.theme

import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.graphics.isBright
import com.varabyte.kobweb.compose.ui.graphics.lightened
import com.varabyte.kobweb.silk.theme.colors.ColorMode

/**
 * @property nearBackground A useful color to apply to a container that should differentiate itself from the background
 *   but just a little.
 *   @property onBackground is nthe textColor
 */
class SitePalette(
    val background: Color,
    val onBackground: Color,
    val nearBackground: Color,
    val cobweb: Color,
    val brand: Brand,
) {

    val onBackgroundLight: Color
        get() {
            return if (!onBackground.isBright)
                onBackground.lightened(0.5f)
            else
                onBackground.darkened(0.5f)
        }

    class Brand(
        val primary: Color = Color.rgb(0x3C83EF),
        val accent: Color = Color.rgb(0xF3DB5B),
        val onPrimary: Color = Colors.White,
    )
}

object SitePalettes {
    val light = SitePalette(
        background = Color.argb(0xffffffff),
        onBackground = Color.argb(0xff1E1E1E),
        nearBackground = Color.rgb(0xF4F6FA),
        cobweb = Colors.LightGray,
        brand = SitePalette.Brand(
            primary = Color.rgb(0xf5F00AA),
            accent = Color.rgb(0xFCBA03),
        )
    )
    val dark = SitePalette(
        background = Color.rgb(0x06080B),
        nearBackground = Color.rgb(0x13171F),
        onBackground = Colors.White,
        cobweb = Colors.LightGray.inverted(),
        brand = SitePalette.Brand(
            primary = Color.rgb(0xf5F00AA),
            accent = Color.rgb(0xF3DB5B),
        )
    )
}

fun ColorMode.toSitePalette(): SitePalette {
    return when (this) {
        ColorMode.LIGHT -> SitePalettes.light
        ColorMode.DARK -> SitePalettes.dark
    }
}